import filterQueryGenerator from 'dashboard/helper/filterQueryGenerator';

// Query do segmento de contatos (spec 007): as condicoes de contato no formato do filtro do Chatwoot (`payload`) e, ao
// lado, o bloco do funil (`kanban`). Sem condicao de contato o payload vai vazio; sem bloco a query e a de sempre.

// Condicoes que o fork acrescenta ao filtro de contatos.
export const SEGMENT_ATTRIBUTES = {
  CONVERSATION_LABELS: 'conversation_labels',
  INBOX_ID: 'inbox_id',
};

const NO_VALUE_OPERATORS = ['is_present', 'is_not_present'];

const isBlankValue = values =>
  values === undefined ||
  values === null ||
  values === '' ||
  (Array.isArray(values) && values.length === 0);

// Condicao ainda sem valor (a linha padrao do painel, por exemplo).
export const isBlankCondition = condition => {
  const operator = condition.filter_operator ?? condition.filterOperator;
  return (
    !NO_VALUE_OPERATORS.includes(operator) && isBlankValue(condition.values)
  );
};

export const buildSegmentQuery = (filters, kanbanBlock = null) => {
  const { payload } = filters?.length
    ? filterQueryGenerator(filters)
    : { payload: [] };
  return kanbanBlock ? { payload, kanban: kanbanBlock } : { payload };
};

// Valores salvos (ids) de volta para as opcoes do seletor ao editar um segmento; null para as chaves do core.
export const segmentConditionValues = (condition, { inboxes = [] } = {}) => {
  const { attribute_key: key, values = [] } = condition;
  if (key === SEGMENT_ATTRIBUTES.CONVERSATION_LABELS) {
    return values.map(title => ({ id: title, name: title }));
  }
  if (key === SEGMENT_ATTRIBUTES.INBOX_ID) {
    return values.map(id => ({
      id,
      name: inboxes.find(inbox => inbox.id === Number(id))?.name ?? String(id),
    }));
  }
  return null;
};
